import {IVanillaReaderUI} from "./IVanillaReaderUI";
import {VanillaReaderUiMenuMediaPlayerController} from "./VanillaReaderUiMenuMediaPlayerController";
import {IVanillaReaderUiComponentController} from "./IVanillaReaderUiComponentController";
import {VanillaReaderUI} from "./VanillaReaderUI";

export interface VanillaReaderUiFunctionButtonsController extends IVanillaReaderUiComponentController, IVanillaReaderUI, VanillaReaderUiMenuMediaPlayerController {}

/**
 * # VanillaReaderUiFunctionButtonsController
 *
 * ## RESPONSIBILITIES
 * This controller mixing class handles all event callbacks from the `VanillaReaderUiFunctionButtons` class.
 *
 * ## RELATED TYPES
 *
 */
export class VanillaReaderUiFunctionButtonsController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.functionButtons.onPanZoomActivate(vanillaReaderUiContext._onPanZoomActivate.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.functionButtons.onPanZoomDeactivate(vanillaReaderUiContext._onPanZoomDeactivate.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.functionButtons.onPlayAmbientMedia(vanillaReaderUiContext._onPlayAmbientMedia.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.functionButtons.onStopAmbientMedia(vanillaReaderUiContext._onStopAmbientMedia.bind(vanillaReaderUiContext));
    }

    
    _onPanZoomActivate(): void {
        this.activatePanZoomTool();
    }

    _onPanZoomDeactivate(): void {
        this.deactivatePanZoomTool();
    }

    _onPlayAmbientMedia(): void {
        this.playAmbientMedia();
    };

    _onStopAmbientMedia(): void {
        this.stopAmbientMedia();
    };
}
